import { useCallback, useMemo } from 'react'

import { RulerDimensionLineIcon } from 'lucide-react'
import { ComboboxMulti } from 'twyne-new.ui'

import {
  definitionToMetric,
  getGroupedCollectionMetrics,
  getMetricDefinition,
} from '../utils/collectionMetrics'

import ConfigField, { CONFIG_CONTROL_CLASS } from './ConfigField'

export default function MetricEditor({ collection, metrics = [], onChange }) {
  const options = useMemo(
    () => getGroupedCollectionMetrics(collection).flatMap(([, items]) => items.map(item => ({
      value: item.key,
      label: item.label,
    }))),
    [collection],
  )

  const selectedKeys = useMemo(
    () => [...new Set(metrics.map(metric => metric?.key).filter(Boolean))],
    [metrics],
  )

  const handleChange = useCallback(nextKeys => {
    const current = new Map(metrics.filter(metric => metric?.key).map(metric => [metric.key, metric]))

    const nextMetrics = nextKeys.map(key => {
      const existing = current.get(key)
      if (existing) return existing

      const definition = getMetricDefinition(collection, key)
      return definition ? definitionToMetric(definition) : null
    })

    onChange(nextMetrics.filter(Boolean))
  }, [collection, metrics, onChange])

  return (
    <ConfigField label="Metrics" icon={RulerDimensionLineIcon}>
      <ComboboxMulti
        className={CONFIG_CONTROL_CLASS}
        options={options}
        value={selectedKeys}
        onChange={handleChange}
        placeholder="Select metrics"
        hideSelectAll
        maxCount={1}
        disabled={!options.length}
      />
    </ConfigField>
  )
}
